"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchLeasingInfo = exports.fetchActive = void 0;
var request_1 = __importDefault(require("../../tools/request"));
/**
 * GET /leasing/active/{address}
 * Get all active leases for an address
 */
function fetchActive(base, address, options) {
    if (options === void 0) { options = Object.create(null); }
    return request_1.default({ base: base, url: "/leasing/active/" + address, options: options });
}
exports.fetchActive = fetchActive;
/**
 * GET /leasing/info/
 * Get lease transactions info.
 */
function fetchLeasingInfo(base, ids, options) {
    if (options === void 0) { options = Object.create(null); }
    var searchParams = "{\"ids\":[" + ids.map(function (id) { return "\"" + id + "\""; }).join(',') + "]}";
    return request_1.default({
        base: base, url: "/leasing/info/", options: __assign(__assign({}, options), { body: searchParams, method: 'POST', headers: {
                'Content-Type': 'application/json'
            } })
    });
}
exports.fetchLeasingInfo = fetchLeasingInfo;
